<template>
    <div class="h-full">
        <video :key="this.options.sources[0].src" ref="videoPlayer" class="video-js  vjs-theme-forest vjs-16-9" controls preload="auto" ></video>
        <div class="h-full" id="video-player-test"></div>
    </div>
</template>

<script>
import axios from "axios";
import videojs from "video.js";
import videojsYoutube from "videojs-youtube";

export default {
    name: "VideoJS",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            player: null,
            token: null
        }
    },
    watch: {
        options: function () {
            
            this.loadSource(() => {
                this.player.src(this.options.sources[0]);
            });
        }
    },
    mounted() {
        this.loadSource(() => {
            this.load();
        })
    },
    methods: {
        loadSource(callback) {
            
            if (this.options.sources[0].src.indexOf('token') !== -1) {
                axios.get('/video/url', {params: {url : this.options.sources[0].src}})
                    .then((data) => {
                        let newUrl = data.data.hls;
                        this.options.sources[0].src = newUrl;
                        // We need to extra the token from the header of the hls file
                        axios.get(newUrl).then((response) => {
                            this.token = response.headers['x-token-session'];

                            // For iOS use a proxy when the video is authenticated
                            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                            if (isIOS) {
                                this.options.sources[0].src = '/video/url/proxy/' + this.options.sources[0].src + '?avh='+this.token;
                            }
                            callback();
                        })
                    });
            } else {
                callback();
            }
        },
        load() {
            // For every one except iOS we add the header to authenticate the video
            videojs.options.hls.overrideNative = true;
            videojs.options.html5.nativeAudioTracks = false;
            videojs.options.html5.nativeVideoTracks = false;
            videojs.Hls.xhr.beforeRequest = (options) => {
                if (!options.headers){
                    options.headers = {};
                }
                if (this.token) {
                    options.headers["X-Token-Session"] = this.token;
                }

                return options;
            }
            this.player = videojs(this.$refs.videoPlayer, this.options, () => {
                this.$emit('on-ready', this.player);
                console.log('onPlayerReady', this);
            })

            this.player.on('loadedmetadata', () => {
                if (this.$store?.state.videoStartTime) {
                    this.player.play();
                    this.$store.commit('goToTime', this.$store.state.videoStartTime);
                }
            })

        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>

<style lang="scss">
    .video-container .vjs-youtube .vjs-poster {
        display: none;
    }
</style>
